import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const BreadcrumbBar = styled.nav`
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
  padding: 1rem 0;
`;

export const BreadcrumbContainer = styled.div`
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const BreadcrumbLink = styled(Link)`
  font-family: var(--font-heading);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  text-decoration: none;
  transition: color var(--transition-fast);

  &:hover {
    color: var(--accent-teal);
  }
`;

export const BreadcrumbSeparator = styled.span`
  font-size: 0.72rem;
  color: var(--text-muted);
  opacity: 0.5;
  user-select: none;
`;

export const BreadcrumbCurrent = styled.span`
  font-family: var(--font-heading);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
`;
